import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { VrstaStavkiKodKupca } from './vrsta-stavki-kod-kupca';

@Component({
  selector: 'yt-vrsta-stavki-kod-kupca-modal-update',
  templateUrl: './vrsta-stavki-kod-kupca-modal-update.component.html'
})
export class VrstaStavkiKodKupcaModalUpdateComponent extends BaseModalUpdateComponent<VrstaStavkiKodKupca> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaStavkiKodKupca>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
